<template>
  <div class="update-schedule-details">
    <schedule-detail-page :schedule-id="scheduleId" />
  </div>
</template>

<script>
import ScheduleDetailPage from '@/components/update-schedules/ScheduleDetailPage.vue';

export default {
  name: 'UpdateDetails',
  components: { ScheduleDetailPage },
  computed: {
    scheduleId() {
      return parseInt(this.$route.params.notificationId, 10);
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .update-schedule-details {
    flex: 1 1 auto;
  }
</style>
